/* DAYEO wishlist (free, stored in the shopper's browser) + card colour-dot image preview. */
(function () {
  if (window.DayeoWishlist) return;
  const KEY = 'dayeo-wishlist';
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
  const write = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} };
  const has = (h) => read().includes(h);
  const toggle = (h) => { const l = read(); const i = l.indexOf(h); if (i > -1) l.splice(i, 1); else l.unshift(h); write(l); return i === -1; };

  function paint(root) {
    (root || document).querySelectorAll('[data-dayeo-heart]').forEach((btn) => {
      const on = has(btn.dataset.dayeoHeart);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      const title = (btn.getAttribute('aria-label') || '').replace(/^(Save|Remove) | (to|from) wishlist$/g, '');
      btn.setAttribute('aria-label', (on ? 'Remove ' : 'Save ') + title + (on ? ' from wishlist' : ' to wishlist'));
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-dayeo-heart]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.dataset.dayeoHeart);
    paint();
    btn.classList.remove('is-pop'); void btn.offsetWidth; btn.classList.add('is-pop');
    document.dispatchEvent(new CustomEvent('dayeo:wishlist'));
  }, true);

  // Colour dots: hovering/focusing a dot previews that colour's photo on the card.
  function preview(dot, on) {
    const card = dot.closest('.card-wrapper');
    if (!card) return;
    const img = card.querySelector('.card__media img');
    if (!img) return;
    if (!img.dataset.dayeoOrig) { img.dataset.dayeoOrig = img.currentSrc || img.src; img.dataset.dayeoSrcset = img.getAttribute('srcset') || ''; }
    if (on && dot.dataset.dayeoImg) { img.removeAttribute('srcset'); img.src = dot.dataset.dayeoImg; }
    else if (!on) { if (img.dataset.dayeoSrcset) img.setAttribute('srcset', img.dataset.dayeoSrcset); img.src = img.dataset.dayeoOrig; }
    card.querySelectorAll('.dayeo-dot').forEach((d) => d.classList.toggle('is-active', on && d === dot));
  }
  document.addEventListener('mouseover', (e) => { const d = e.target.closest('.dayeo-dot'); if (d) preview(d, true); });
  document.addEventListener('mouseout', (e) => { const d = e.target.closest('.dayeo-dot'); if (d && !d.contains(e.relatedTarget)) preview(d, false); });
  document.addEventListener('focusin', (e) => { const d = e.target.closest('.dayeo-dot'); if (d) preview(d, true); });
  document.addEventListener('focusout', (e) => { const d = e.target.closest('.dayeo-dot'); if (d) preview(d, false); });

  // Wishlist page renderer
  async function renderPage() {
    const root = document.querySelector('[data-dayeo-wishlist-page]');
    if (!root) return;
    const grid = root.querySelector('.dayeo-wishlist__grid');
    const count = root.querySelector('.dayeo-wishlist__count');
    const empty = root.querySelector('.dayeo-wishlist__empty');
    const list = read();
    count.textContent = list.length === 1 ? '1 item' : list.length + ' items';
    empty.hidden = list.length > 0;
    grid.innerHTML = '';
    const fmt = (cents) => (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : 'LE ' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2 });
    const items = await Promise.all(list.map((h) => fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + encodeURIComponent(h) + '.js').then((r) => (r.ok ? r.json() : null)).catch(() => null)));
    items.forEach((p, i) => {
      if (!p) return;
      const li = document.createElement('li');
      li.className = 'dayeo-wl-card';
      const img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
      li.innerHTML =
        '<a class="dayeo-wl-card__media" href="' + p.url + '">' + (img ? '<img src="' + img + (img.includes('?') ? '&' : '?') + 'width=533" alt="" loading="lazy">' : '') + '</a>' +
        '<button type="button" class="dayeo-heart" data-dayeo-heart="' + list[i] + '" aria-pressed="true" aria-label="Remove ' + p.title.replace(/"/g, '&quot;') + ' from wishlist"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-7.5-10.3A4.2 4.2 0 0 1 12 7.6a4.2 4.2 0 0 1 7.5 2.6c0 5.7-7.5 10.3-7.5 10.3z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg></button>' +
        '<a class="dayeo-wl-card__title" href="' + p.url + '"></a>' +
        '<p class="dayeo-wl-card__price">' + fmt(p.price) + '</p>';
      li.querySelector('.dayeo-wl-card__title').textContent = p.title;
      grid.appendChild(li);
    });
  }

  document.addEventListener('dayeo:wishlist', () => { if (document.querySelector('[data-dayeo-wishlist-page]')) renderPage(); });
  const start = () => { paint(); renderPage(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  new MutationObserver(() => paint()).observe(document.documentElement, { childList: true, subtree: true });

  window.DayeoWishlist = { read, toggle, has };
})();
